// frontend/src/services/siteService.js
/* 
Provides API helper functions for fetching site data from the backend.
Encapsulates HTTP requests for:
- Company-owned active sites (UPS selector view)
- Agency contract-allowed active sites
- UPS Admin full site list (active + inactive)
*/

import axios from 'axios';

/**
 * Fetch ACTIVE sites for the logged-in user's company.
 * Used for operational selectors.
 * Endpoint: GET /sites
 */
export async function fetchMyCompanySites() {
  const { data } = await axios.get('/sites');

  // support both: { sites: [...] } and [...]
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.sites)) return data.sites;

  return [];
}

/**
 * Fetch ACTIVE sites the current agency is allowed to operate on
 * (contract active + contract_site enabled).
 * Endpoint: GET /agencies/me/sites
 */
export async function fetchMyAgencyAllowedSites() {
  const { data } = await axios.get('/agencies/me/sites');

  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.sites)) return data.sites;

  return [];
}

/**
 * Fetch ALL sites for UPS Admin Manage Sites screen.
 * Includes both active and inactive.
 * Endpoint: GET /ups-admin/sites
 */
export async function fetchUpsAdminSites() {
  const { data } = await axios.get('/ups-admin/sites');

  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.sites)) return data.sites;

  return [];
}
